import React from 'react'
import '../../styles/index.css'

import { Navbar } from '../Navbar'

import 'react-toastify/dist/ReactToastify.css'
import 'react-toggle/style.css'
import { Footer } from '../footer'

interface LayoutProps {
  children: React.ReactNode
  containerClass?: string
}

export const Layout = ({ children, containerClass }: LayoutProps) => (
  <>
    <Navbar />
    <div className={`container layout ${containerClass || ""}`}>
      <main>{children}</main>
    </div>
    <Footer />
  </>
)
